import { apiInstance, handleApiError } from "./InstanceApi";

export const searchReferenceData = async ({
  page = 1,
  limit = 10,
  name = "",
  data = "",
}) => {
  try {
    const response = await apiInstance.get("/reference-data/search", {
      params: {
        page: page,
        limit: limit,
        name: name,
        data: data,
      },
    });
    return response.data;
  } catch (error) {
    return handleApiError(error);
  }
};

export const createReferenceData = async (data) => {
  try {
    const response = await apiInstance.post("/reference-data", data);
    return response.data;
  } catch (error) {
    return handleApiError(error);
  }
};

export const updateReferenceData = async ({id, data}) => {
  try {
    const response = await apiInstance.put(`/reference-data/${id}`, data);
    return response.data;
  } catch (error) {
    return handleApiError(error);
  }
};

export const deleteReferenceById = async (id) => {
  try {
    const response = await apiInstance.delete(`/reference-data/${id}`);
    return response.data;
  } catch (error) {
    return handleApiError(error);
  }
};

export const importReferenceDataCsv = async (file) => {
  try {
    const formData = new FormData();
    formData.append("file", file);
    const response = await apiInstance.post(
      "/reference-data/import",
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
    return response.data;
  } catch (error) {
    return handleApiError(error);
  }
};
